import {Option, option} from "ts-option";
import {RootState} from "../reducer/root/RootState";
import Lead from "../../model/lead/Lead";

/**
 * Gets lead.
 * @param {string} leadIdOrRefNumber Lead identifier to get.
 * @param {RootState} state State of the redux.
 * @returns {Option<Lead>} Lead.
 */
export function getLeadByIdOrRefNo(leadIdOrRefNumber: string, state: RootState): Option<Lead> {
	const lead = state.lead.leadsMap[leadIdOrRefNumber];
	return option(lead);
}

/**
 * Returns true if all data needed to display lead are in redux store.
 * @param {RootState} state State of the redux.
 * @returns {boolean} true if can display lead, false otherwise.
 */
export function canDisplayLead(state: RootState) {
	const acquisitionChannels = state.acquisitionChannel.acquisitionChannels;
	const tags = state.lead.tags;
	return acquisitionChannels.isDefined && tags.isDefined
}